import React, {useState, useEffect} from 'react';
import Input from '../global/Input';
import {useGetBundeslandQuery} from '../../redux/rtk/injectedIsoBundeslandApi';

type Props={
    validationRules?: any;
    validationErrorMessage?: any;
    validationControl?: any;
    value?: any;
    label: any;
    onChange?: (e: any) => void,
    setValue?: (e: any) => void,
    name:string
}

const IsoCodeSelectList=(props:Props):JSX.Element=>{
    const [list, setList] = useState<any>([]);
    const {
        data: isobundesland = [], isLoading
    } = useGetBundeslandQuery();

    useEffect(()=>{
        let tmp: any = [];
        if (isLoading) {
            tmp=[{value:0, label:'Lädt'}];
        } else {
            isobundesland.forEach((key: { id: any; name: any; })=>{
                tmp.push({
                    value: key.id,
                    // label: key.code + ': ' + key.name,
                    label: key.name,
                });
            });
        }
        setList(tmp);
    },[isLoading]);


    return (<Input
        edit={true}
        name={props.name ? props.name : 'iso_code_countys'}
        dropdownOptions={list}
        scrollHeight={'350px'}
        type={'dropdown'}
        label={props.label}
        value={props.value}
        onChange={(e:any)=>{
            if ( props.setValue) props.setValue(e.value) ;
            if (props.onChange) props.onChange(e);
        }}
        validationControl={props.validationControl}
        validationErrorMessage={props.validationErrorMessage}
        validationRules={props.validationRules}
    />);
};
export default IsoCodeSelectList;
